module.exports = __webpack_public_path__ + "static/media/KD.37549797.svg";